module.exports = __webpack_public_path__ + "img/defaultVoucherIco.02beaa0f.png";